export class TopicModel {
  constructor(
    public id: number,
    public title: string,
    public subTitle: string,
    public content: string
  ) {}
}
